import MerchandiserInvoicingStatuses from "data/merchandiser-invoicing-statuses";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import React from "react";

const statusFilter = ({ filter, onChange }) => {
    const options = {};
    options[""] = MerchandiserInvoicingStatuses.AllCharges.title;
    Object.keys(MerchandiserInvoicingStatuses).forEach(key => {
        if (key !== "AllCharges") {
            options[key] = MerchandiserInvoicingStatuses[key].title;
        }
    });
    delete options.AllApproved;
    return (
        <ReactTableFilterSelect
            currentValue={filter ? filter.value : ""}
            onChange={value => onChange(value)}
            style={{ width: "100%", height: "100%" }}
            optionsObject={options}
        />
    );
};

export default statusFilter;
